import './SliderNavigation.scss';
import template from './SliderNavigation.vhtml';

export default {
	name: 'SliderNavigation',
	template,
	methods: {
		next() {
			this.$emit('next');
		},
		prev() {
			this.$emit('prev');
		}
	},
};
